var _g;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgBoxPencil(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 25,
    height: 24
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0 0h24v24H0z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#151A30",
    d: "M10.303 9.143A8.074 8.074 0 007.9 14.9a8.098 8.098 0 004.2 7.1H2.43a1.426 1.426 0 01-1.422-1.29L1 20.57V9.143h9.303zM16 8.4a6.501 6.501 0 010 13 6.501 6.501 0 010-13zm.385 4.363l-3.59 3.59-.29 1.662a.329.329 0 00.38.38l1.661-.291 3.59-3.59a.164.164 0 000-.233l-1.517-1.518a.167.167 0 00-.234 0zm-2.682 3.777v.656h.656v.496l-.882.155-.425-.425.155-.882h.496zm4.782-4.948a.657.657 0 00-.928 0l-.63.63a.164.164 0 000 .232l1.517 1.518a.165.165 0 00.233 0l.63-.63a.656.656 0 000-.929zM17.112 2a1.43 1.43 0 011.305.846l.052.132 2.513 4.683-.02.027-.02.026H19.74A8.062 8.062 0 0016 6.8a8.06 8.06 0 00-3.74.914h-.546V2h5.398zm-6.826 0v5.714H1.058l-.02-.027-.02-.026L3.53 2.978c.182-.54.66-.916 1.217-.971L4.888 2h5.398z"
  }))));
}

export default SvgBoxPencil;